import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div data-testid="privacy-page" style={{ minHeight: '100vh', backgroundColor: '#000', color: '#FAF3E0', fontFamily: "'Georgia', serif" }}>
      <div style={{ borderBottom: '1px solid rgba(212,175,55,0.15)', padding: '16px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span onClick={() => navigate('/')} style={{ cursor: 'pointer', fontFamily: "'Georgia', serif", fontSize: 20, color: '#D4AF37', letterSpacing: 4, fontWeight: 600 }}>
          BOBINE
        </span>
        <button onClick={() => navigate(-1)} style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', background: 'none', border: '1px solid rgba(212,175,55,0.3)', borderRadius: 8, padding: '8px 20px', cursor: 'pointer' }}>
          Retour
        </button>
      </div>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px 80px' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <h1 data-testid="privacy-title" style={{ fontSize: 28, color: '#D4AF37', fontWeight: 600, letterSpacing: 1.5, marginBottom: 8 }}>
            {"Politique de Confidentialit\u00e9"}
          </h1>
          <div style={{ width: 60, height: 1, background: 'linear-gradient(145deg, #D4AF37, #B8860B)', margin: '16px auto', opacity: 0.4 }} />
          <p style={{ fontSize: 13, color: '#D4AF37', fontStyle: 'italic' }}>
            {"Derni\u00e8re mise \u00e0 jour\u00a0: mars 2026"}
          </p>
        </div>

        <section data-testid="privacy-engagement" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>Engagement</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"Chez Bobine, vos souvenirs sont sacr\u00e9s. Nous ne vendons jamais vos donn\u00e9es et n\u2019analysons pas vos vid\u00e9os \u00e0 des fins publicitaires."}
          </p>
        </section>

        <section data-testid="privacy-donnees" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>{"Donn\u00e9es collect\u00e9es"}</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"Nous ne collectons que les donn\u00e9es strictement n\u00e9cessaires\u00a0: votre e-mail (pour le compte) et vos coordonn\u00e9es de paiement (g\u00e9r\u00e9es de mani\u00e8re s\u00e9curis\u00e9e par notre partenaire "}
            <strong style={{ color: '#D4AF37' }}>Stripe</strong>
            {")."}
          </p>
        </section>

        <section data-testid="privacy-utilisation" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>{"Utilisation des donn\u00e9es"}</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"Vos souvenirs sont stock\u00e9s sur des serveurs s\u00e9curis\u00e9s et ne sont accessibles qu\u2019aux personnes que vous invitez explicitement (vos \u00ab\u00a0Alli\u00e9s\u00a0\u00bb)."}
          </p>
        </section>

        <section data-testid="privacy-paiement" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>Paiement</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"Vos informations bancaires ne transitent jamais par nos serveurs\u00a0; elles sont crypt\u00e9es par Stripe."}
          </p>
        </section>

        <section data-testid="privacy-droits" style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: 18, color: '#D4AF37', marginBottom: 12, fontWeight: 500 }}>Vos Droits</h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#FAF3E0' }}>
            {"Conform\u00e9ment au RGPD, vous disposez d\u2019un droit d\u2019acc\u00e8s, de modification et de suppression totale de vos donn\u00e9es sur simple demande \u00e0 "}
            <a href="mailto:bonjour@bobine.live" style={{ color: '#D4AF37', textDecoration: 'none', borderBottom: '1px solid rgba(212,175,55,0.3)' }}>
              bonjour@bobine.live
            </a>
            {"."}
          </p>
        </section>

        <div style={{ borderTop: '1px solid rgba(212,175,55,0.1)', paddingTop: 32, marginTop: 48, textAlign: 'center' }}>
          <p style={{ fontSize: 12, color: '#D4AF37' }}>
            {"Bobine \u2014 Le fil de la m\u00e9moire \u2022 "}
            <a href="mailto:bonjour@bobine.live" style={{ color: '#D4AF37', textDecoration: 'none' }}>bonjour@bobine.live</a>
          </p>
          <p style={{ fontSize: 11, color: '#D4AF37', marginTop: 8 }}>
            <a href="/terms" style={{ color: '#D4AF37', textDecoration: 'none' }}>{"Conditions G\u00e9n\u00e9rales d\u2019Utilisation"}</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
